import React from 'react';
import Header from './Header';
import Footer from './Footer';

const ReturnsPolicy = () => {
  return (
    <>
      <Header />
      <div className="page-offset policy-offset">
        <section className="returns-policy">
          <div className="container">
            <h1 className="h1 section-title">Returns Policy</h1>
            <div className="returns-content">
              <p className="returns-intro">
                <strong>Oracle Gaming</strong> wants you to be completely satisfied with your purchase. 
                This Returns Policy outlines our procedures for returns, exchanges, and refunds to ensure 
                a smooth and fair process for all our customers.
              </p>

              <div className="returns-section">
                <h2 className="h2">Return Timeframes</h2>
                <p>We offer a <strong>14-day return window</strong> from the date of delivery for most items.</p>
                
                <h3 className="h3">Different Timeframes by Product Type</h3>
                <ul>
                  <li><strong>Trading Cards (Unopened):</strong> 14 days from delivery</li>
                  <li><strong>Gaming Accessories:</strong> 14 days from delivery</li>
                  <li><strong>Merchandise & Apparel:</strong> 14 days from delivery</li>
                  <li><strong>Tournament Entry Fees:</strong> Non-refundable (see special conditions below)</li>
                </ul>
              </div>

              <div className="returns-section">
                <h2 className="h2">Return Conditions</h2>
                <p>To be eligible for a return, items must meet the following conditions:</p>
                
                <h3 className="h3">Acceptable Returns</h3>
                <ul>
                  <li><strong>Unopened Items:</strong> All items must be in their original, unopened packaging</li>
                  <li><strong>Original Condition:</strong> Items must be in the same condition as when delivered</li>
                  <li><strong>Original Packaging:</strong> All original packaging, tags, and accessories must be included</li>
                  <li><strong>Proof of Purchase:</strong> Original receipt or order confirmation required</li>
                </ul>

                <h3 className="h3">Items That Cannot Be Returned</h3>
                <ul>
                  <li><strong>Opened Trading Card Packs:</strong> Once opened, trading card packs cannot be returned</li>
                  <li><strong>Personalized Items:</strong> Custom or personalized products are non-returnable</li>
                  <li><strong>Tournament Entry Fees:</strong> Event registrations and tournament fees are non-refundable</li>
                  <li><strong>Digital Products:</strong> Any digital downloads or online content</li>
                  <li><strong>Sale/Clearance Items:</strong> Items purchased during special sales may have different return policies</li>
                </ul>
              </div>

              <div className="returns-section">
                <h2 className="h2">Return Process</h2>
                <p>To initiate a return, please follow these steps:</p>
                
                <h3 className="h3">Step 1: Contact Us</h3>
                <p>Before sending any items back, you must contact us first:</p>
                <ul>
                  <li><strong>Email:</strong> <a href="mailto:oraclegaming.za@gmail.com">oraclegaming.za@gmail.com</a></li>
                  <li><strong>Phone:</strong> <a href="tel:0825655408">082 565 5408</a></li>
                  <li>Include your order number and reason for return</li>
                </ul>

                <h3 className="h3">Step 2: Return Authorization</h3>
                <p>We will provide you with:</p>
                <ul>
                  <li><strong>Return Authorization Number:</strong> Required for processing your return</li>
                  <li><strong>Return Instructions:</strong> Specific packaging and shipping requirements</li>
                  <li><strong>Return Label:</strong> Pre-paid return shipping label (when applicable)</li>
                </ul>

                <h3 className="h3">Step 3: Package & Ship</h3>
                <p>Package your items securely and ship using the provided return label or instructions.</p>
              </div>

              <div className="returns-section">
                <h2 className="h2">Return Shipping Costs</h2>
                <p>Return shipping costs depend on the reason for return:</p>
                
                <div className="returns-options">
                  <div className="returns-option">
                    <h4>Damaged/Defective Items</h4>
                    <p><strong>Cost:</strong> Free return shipping</p>
                    <p><strong>Process:</strong> We provide return label</p>
                    <p>Items damaged during shipping or defective upon arrival.</p>
                  </div>
                  <div className="returns-option">
                    <h4>Unwanted Items</h4>
                    <p><strong>Cost:</strong> Customer pays return shipping</p>
                    <p><strong>Process:</strong> Customer arranges return shipping</p>
                    <p>Items returned due to change of mind or incorrect order.</p>
                  </div>
                </div>
              </div>

              <div className="returns-section">
                <h2 className="h2">Refund Processing</h2>
                <p>Once we receive your returned items:</p>
                <ul>
                  <li><strong>Inspection Period:</strong> Items are inspected within 2-3 business days</li>
                  <li><strong>Processing Time:</strong> Refunds are processed within 7 business days</li>
                  <li><strong>Refund Method:</strong> Refunds are issued to the original payment method</li>
                  <li><strong>Store Credit Option:</strong> We can also provide store credit if preferred</li>
                </ul>
              </div>

              <div className="returns-section">
                <h2 className="h2">Exchanges</h2>
                <p>We offer exchanges for:</p>
                <ul>
                  <li><strong>Size Exchanges:</strong> Apparel and accessories in different sizes</li>
                  <li><strong>Color Variations:</strong> Same item in different colors (if available)</li>
                  <li><strong>Similar Items:</strong> Items of equal or greater value</li>
                </ul>
                <p>
                  <strong>Note:</strong> Exchanges are subject to availability. If the desired item is not available, 
                  we will process a refund instead.
                </p>
              </div>

              <div className="returns-section">
                <h2 className="h2">Special Items & Conditions</h2>
                
                <h3 className="h3">Pre-Orders</h3>
                <p>We do not accept pre-orders. All items are in stock and ready to ship.</p>

                <h3 className="h3">Limited Edition Items</h3>
                <p>Limited edition and rare items receive extra care during the return process:</p>
                <ul>
                  <li>Enhanced packaging requirements</li>
                  <li>Detailed condition inspection</li>
                  <li>Specialized handling procedures</li>
                </ul>

                <h3 className="h3">Tournament Entry Fees</h3>
                <p>
                  <strong>Tournament entry fees and event registrations are non-refundable.</strong> 
                  This includes but is not limited to:
                </p>
                <ul>
                  <li>Weekly tournament entries</li>
                  <li>Special event registrations</li>
                  <li>Championship entries</li>
                  <li>Workshop or clinic fees</li>
                </ul>
              </div>

              <div className="returns-section">
                <h2 className="h2">Damaged or Defective Items</h2>
                <p>If you receive damaged or defective items:</p>
                <ul>
                  <li><strong>Immediate Contact:</strong> Contact us within 48 hours of delivery</li>
                  <li><strong>Photo Documentation:</strong> Provide photos of the damage or defect</li>
                  <li><strong>Free Return:</strong> We provide return shipping label at no cost</li>
                  <li><strong>Quick Resolution:</strong> Priority processing for damaged items</li>
                  <li><strong>Replacement or Refund:</strong> Your choice of replacement or full refund</li>
                </ul>
              </div>

              <div className="returns-section">
                <h2 className="h2">Contact Information</h2>
                <p>For all return inquiries, please contact us:</p>
                <div className="contact-info">
                  <p><strong>Email:</strong> <a href="mailto:oraclegaming.za@gmail.com">oraclegaming.za@gmail.com</a></p>
                  <p><strong>Phone:</strong> <a href="tel:0825655408">082 565 5408</a></p>
                  <p><strong>Business Hours:</strong> Monday - Friday, 9:00 AM - 5:00 PM</p>
                  <p><strong>Response Time:</strong> We respond to return inquiries within 24 hours</p>
                </div>
              </div>

              <div className="returns-section">
                <h2 className="h2">Important Notes</h2>
                <ul>
                  <li>Returns without prior authorization will not be accepted</li>
                  <li>Items must be returned within the specified timeframe</li>
                  <li>We reserve the right to refuse returns that don't meet our conditions</li>
                  <li>Refunds may take 1-2 billing cycles to appear on your statement</li>
                  <li>Store credit never expires and can be used for future purchases</li>
                  <li>This policy applies to purchases made directly from Oracle Gaming</li>
                </ul>
              </div>

              <div className="returns-footer">
                <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-ZA', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                <p>This returns policy is subject to change. Please check back regularly for updates.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ReturnsPolicy;
